<template lang="pug">
  v-dialog(
    v-model="active"
    persistent
    width="400"
  )
    v-card(:loading="loading")
      v-card-title
        | New Ad Group

      v-card-text
        v-layout(column)
          v-flex
            v-text-field(
              label="Name"
              v-model="form.name"
            )

      v-card-actions.pa-3
        v-layout
          v-flex(xs6)
            v-btn(block color="green" @click="doSubmit") Submit
          v-flex(xs6)
            v-btn(block @click="active = false") Close
</template>

<script>
import ads from '@/services/googles/ads'

const FORM_DEFAULT = {
  name: ''
}

export default {
  props: {
    customerId: [String, Number],
    campaignId: [String, Number]
  },
  data () {
    return {
      active: false,
      loading: false,
      form: Object.assign({}, FORM_DEFAULT)
    }
  },
  mounted () {
  },
  methods: {
    show () {
      this.active = true
      this.loading = false
      this.form = Object.assign({}, FORM_DEFAULT)
    },
    hide () {
      this.active = false
    },
    doCreateAdGroup (name) {
      const create = {
        name: name,
        campaign: `customers/${this.customerId}/campaigns/${this.campaignId}`
      }
      return ads.addAdGroup(this.customerId, create)
    },
    async doSubmit () {
      this.loading = true

      const name = this.form.name
      await this.doCreateAdGroup(name)

      this.hide()
      this.$emit('complele', true)
    }
  }
}
</script>
